var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "slot-strip", style: { "--sp-per-page": _vm.daysPerPage } },
    [
      _c("div", { staticClass: "slot-strip-head" }, [
        _c(
          "button",
          {
            staticClass: "slot-strip-nav",
            attrs: {
              type: "button",
              disabled: _vm.atStart,
              "aria-label": _vm._f("translate")("Earlier times"),
            },
            on: {
              click: function ($event) {
                return _vm.page(-1)
              },
            },
          },
          [_c("i", { staticClass: "fas fa-chevron-left" })]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "slot-strip-range" }, [
          _vm._v(_vm._s(_vm.visibleRange)),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "slot-strip-nav",
            attrs: {
              type: "button",
              disabled: _vm.atEnd,
              "aria-label": _vm._f("translate")("Later times"),
            },
            on: {
              click: function ($event) {
                return _vm.page(1)
              },
            },
          },
          [_c("i", { staticClass: "fas fa-chevron-right" })]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "slot-strip-days",
          attrs: {
            role: "group",
            "aria-label": _vm._f("translate")("Available times"),
          },
          on: {
            "&touchstart": function ($event) {
              return _vm.onTouchStart.apply(null, arguments)
            },
            "&touchend": function ($event) {
              return _vm.onTouchEnd.apply(null, arguments)
            },
          },
        },
        _vm._l(_vm.visibleColumns, function (day) {
          return _c("div", { key: day.key, staticClass: "slot-day" }, [
            _c(
              "div",
              {
                staticClass: "slot-day-head",
                class: {
                  "is-today": day.isToday,
                  "is-selected": day.key === _vm.selectedDayKey,
                },
              },
              [
                _c("span", { staticClass: "slot-day-weekday" }, [
                  _vm._v(_vm._s(_vm._f("translate")(day.weekdayLabel))),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "slot-day-date" }, [
                  _vm._v(_vm._s(day.shortDate)),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "slot-day-times" },
              [
                _vm._l(day.cells, function (cell) {
                  return [
                    cell.slot
                      ? _c(
                          "button",
                          {
                            key: cell.key,
                            staticClass: "slot-time",
                            class: { "is-selected": _vm.isSelected(cell.slot) },
                            style: { gridRow: cell.row },
                            attrs: {
                              type: "button",
                              "aria-pressed": String(_vm.isSelected(cell.slot)),
                              title: `${day.title}, ${cell.slot.label}`,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.choose(cell.slot)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(cell.slot.startTime) +
                                "\n          "
                            ),
                          ]
                        )
                      : _c(
                          "span",
                          {
                            key: `${cell.key}-else`,
                            staticClass: "slot-empty",
                            style: { gridRow: cell.row },
                            attrs: { "aria-hidden": "true" },
                          },
                          [_vm._v("–")]
                        ),
                  ]
                }),
              ],
              2
            ),
          ])
        }),
        0
      ),
      _vm._v(" "),
      _vm.hasMoreSlots
        ? _c("div", { staticClass: "slot-strip-more" }, [
            _c(
              "button",
              {
                staticClass: "slot-strip-more-btn",
                attrs: { type: "button" },
                on: { click: _vm.showMoreSlots },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm._f("translate")("Show more")) +
                    "\n      "
                ),
                _c("i", { staticClass: "fas fa-chevron-down" }),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showZone
        ? _c("div", { staticClass: "slot-strip-zone" }, [
            _c("i", { staticClass: "fas fa-globe" }),
            _vm._v("\n    " + _vm._s(_vm.zoneLabel) + "\n  "),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }